module.exports = __webpack_public_path__ + "img/qr.a0fd97c7.png";